/**
 * web/src/hooks/queries/useEventTemplates.ts
 * Stored ops next-steps template sources for an event (GET /:id/templates).
 * Powers the EventConfigure ingestion-status view. Disabled until an id is
 * provided + the caller opts in (the config page only fetches when the
 * Templates section is shown).
 */
import { useQuery } from '@tanstack/react-query';
import { fetchEventTemplates } from '../../api/events';
import { qk } from '../../lib/queryKeys';

/**
 * Fetches GET /api/events/:id/templates.
 *
 * @param id event id; required
 * @param opts.enabled default true; pass false to gate the request behind a UI action
 * @returns React Query result for TemplateSourceView[]
 * @sideEffects HTTP GET
 * @idempotent yes
 */
export function useEventTemplates(id: string | undefined, opts: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: qk.events.templates(id),
    queryFn: () => fetchEventTemplates(id!),
    enabled: id != null && opts.enabled !== false,
    staleTime: 30_000,
  });
}
